// React
import React, { Component } from 'react';
import {IconButton} from '@material-ui/core/';
import {functions} from 'constants/index';
import {Edit, Delete} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import LoadingSpinner from 'components/LoadingSpinner';
import {showMessageErrorSimple, showMessageError} from 'services/SweetAlert'
import ModalObservation from 'components/ModalObservation';
// import ProcesarSolicitudTSEVirtual from './Dialog'
import DialogLoadingMessage from 'components/LoadingMessage/index'
class ListadoDeRegistrosEliminados extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'captacionBitacora',
            loading: false,
            authorized:true,
            checkAutorization:true,
            data: [],
            header: [
                { title: 'ID Bitácora', field: 'idbitacora',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Fallecido', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Nombre Padre', field: 'nombrePadreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Nombre Madre', field: 'nombreMadreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Departamento defunción', field: 'datosfolio.departamentov.nameShort' },
                { title: 'Municipio defunción', field: 'datosfolio.municipiov.municipio',
                render: rowData=><div>
                    {
                        (rowData.datosfolio?.auxiliatura === null) ?
                         (rowData.datosfolio?.municipiov?.municipio) :
                         (rowData.datosfolio?.auxiliatura?.municipio?.municipio)
                    }
                </div>
                },
                { title: 'Auxiliatura', field: 'datosfolio.auxiliatura.name', },                
                { title: 'Fecha Defunción', field: 'fechaDefuncionformato' },
                { title: 'Fecha Defunción Asentamiento', field: 'fechaasientoString' },
                { title: 'CUI', field: 'cui' },
                { title: 'Cédula', field: 'cedula' },
                { title: 'Departamento Extensión', field: 'deptoextension.nameShort' },
                { title: 'Municipio Extensión', field: 'muniextension.municipio' },
                { title: 'Número boleta', field: 'nroboleta' },
                { title: 'Departamento Nacimiento', field: 'deptonacimiento.nameShort' },
                { title: 'Municipio Nacimiento', field: 'muninacimiento.municipio' },
                { title: 'Fecha Nacimiento', field: 'fechaNacimientoformato' },
                { title: 'Usuario creación', field: 'usuariocreacion', },
                { title: 'Usuario procesó', field: 'usuarioprocesa', },
                { title: 'Fecha de eliminación', field: 'fechaEliminacionformato', },
                { title: 'Hora de eliminación', field: 'horaEliminacionString', },
                { title: 'Tipo Motivo', field: 'motivo.tipomotivo', },
                { title: 'Observación', field: 'observacion', 
                    render: (rowData) => (
                        <div>
                            {(rowData.observacion !== null) ? (
                                <IconButton  size="small" color="primary"
                                    onClick={() => {
                                        let observacion = []
                                        observacion.push({title: rowData.observacion, text:''})
                                        this.abrirObservacion();
                                        this.setState({ textoObservacion: observacion, title:'Observaciones' })
                                    }}
                                >
                                    <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                                </IconButton>
                            ) : ""}
                        </div>
                )},
                { title: 'Origen', field: 'datosfolio.datosorigen', },                
                { title: 'Folio No.', field: 'datosfolio.idfolio',cellStyle:{ maxWidth: '80px' } },
                { title: 'Datos folio', field: '', 
                    render: (rowData) => (
                        <div>
                            {(rowData.datosfolio) ? (
                                <IconButton  size="small" color="primary"
                                    onClick={() => {
                                        let observacion = []
                                        observacion.push({title:'Origen: ', text: rowData?.datosfolio?.datosorigen})                                        
                                        observacion.push({title:'Folio: ', text: rowData?.datosfolio?.idfolio})
                                        observacion.push({title:'Departamento: ', text: rowData?.datosfolio?.departamentov?.nameShort})
                                        observacion.push({title:'Municipio: ', text: (
                                            (rowData?.datosfolio?.auxiliatura === null) ?
                                            (rowData?.datosfolio?.municipiov?.municipio) :
                                            (rowData?.datosfolio?.auxiliatura?.municipio?.municipio)                                            
                                        )})
                                        observacion.push({title: 'Auxiliatura: ', text: (rowData.datosfolio?.auxiliatura?.name) ? (rowData.datosfolio?.auxiliatura?.name):('')})
                                        observacion.push({title: 'Año: ', text: rowData?.datosfolio?.año})
                                        observacion.push({title: 'Fecha Inicio: ', text: functions.dateFormatGeneral(rowData?.datosfolio?.fechainicio)})
                                        observacion.push({title: 'Fecha Final: ', text: functions.dateFormatGeneral(rowData?.datosfolio?.fechafinal)})
                                        this.abrirObservacion();
                                        this.setState({ textoObservacion: observacion, title:'Datos del Folio' })
                                    }}
                                >
                                    <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                                </IconButton>
                            ) : ""}
                        </div>
                )},                
            ],
            currentUser: props.currentUser,
            abrirModalTSEVirtual: false,
            // formulario captación de fallecidos
            openFormCaptacionFallecidos: false,
            textoObservacion: '', title: '', openObservacion:false,
        }
    //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);
        this.abrirObservacion = this.abrirObservacion.bind(this);
        this.cerrarObservacion = this.cerrarObservacion.bind(this);
    }
    abrirObservacion(){
        this.setState({ openObservacion: true })
    }
    cerrarObservacion(){
        this.setState({ openObservacion: false })
    }    
    // cargamos todos los registros que ya fueron procesados, estado fallecido
        async showList(){
            try{
                this.setState({loading: true, checkAutorization: true});
                const hasPermission = await ApiServices.userSecurity.hasPermission(this.state.controller,'list');    
                if (hasPermission.error){
                    this.setState({checkAutorization: false,authorized: false,loading: false });
                }else{
                    ApiServices[this.state.controller].initSearchCriteria.clear();
                    ApiServices[this.state.controller].initOrderCriteria.clear();
                    ApiServices[this.state.controller].initOrderCriteria.addDesc("idbitacora");
                    this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
                }
            }catch(exception){
                if(exception.status===404) {
                    showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }else {
                    showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
                }
                this.setState({ loading: false,checkAutorization: false, data:[]});
            }
        }
        async componentDidMount() {  
            this.showList();
        }

    render() {
        if (this.state.checkAutorization ) return <DialogLoadingMessage open={this.state.loading} title={'Cargando listado de registros eliminados de origen SISTEMA ...'}/> 
        return (
            <div>
                <ModalObservation open={this.state.openObservacion}  handleClose={this.cerrarObservacion} textoObservacion={this.state.textoObservacion} title={this.state.title} />
                {/* <ModalObservation open={this.state.openObservacion}  handleClose={this.cerrarObservacion} textoObservacion={this.state.textoObservacion} title={this.state.title} /> */}
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}
                {window.screen.width >= 1024 ? (
                    <Table  
                            service={ApiServices[this.state.controller]}
                            title={"Listado de registros eliminados de origen SISTEMA"}
                            header = {this.state.header}                             
                            refreshList={this.showList}
                            showFilterGeneral={false}
                    />
                ) : ("") }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListadoDeRegistrosEliminados);